import { DefaultTheme } from 'styled-components'
import { merge } from 'lodash'
import { wscTheme } from '@wsc_sports/components-library'
import { defaultTheme } from '../../@wsc/ui/theme/defaultTheme'

const spacer = 16

export const theme: DefaultTheme = merge(
  {},
  defaultTheme,
  { wsc: wscTheme },
  {
    colors: {
      blue1: '#397fff',
      blue2: '#305fb0',
      primary: '#5aa3ff',
      primaryHover: '#80b8ff',
      primarySelected: '#1352a3',
      primaryOpacity30040: 'rgba(90, 163, 255, 0.40)',

      gray1: '#dbdbdb',
      gray2: '#b2b2b2',

      white: '#fff',
      black: '#000',

      white80: 'rgba(255, 255, 255, 0.8)',
      white92: 'rgba(255, 255, 255, 0.92)',
      white20: 'rgba(255, 255, 255, 0.2)',
      white60: 'rgba(255, 255, 255, 0.6)',

      neutral100: '#808080',

      success: '#00B27C',
      warning: '#ffae00',
      danger: '#ff364e',
      disabled: '#00000099',
      secondary: '#636363',

      gray900: '#131313',
      gray800: '#272727',
      gray700: '#3b3b3c',
      gray600: '#474747',
      gray500: '#636363',
      gray400: '#7f7f7f',
      gray300: '#9c9c9c',
      gray200: '#b8b8b8',
      gray100: '#d4d4d4',

      purple300: '#e282e2',

      yellow500: '#DDCA01',
      yellow700: '#CCBA00',
    },
    shadow: {
      danger: '255, 54, 78',
    },
    sizes: {
      mobileWidth: '768px',
      timelineRulerMusicViolationHeight: 7,
    },
    spaces: [
      `${0 * spacer}px`, //0px
      `${0.25 * spacer}px`, //4px
      `${0.5 * spacer}px`, //8px
      `${1 * spacer}px`, //16px
      `${1.5 * spacer}px`, //24px
      `${2 * spacer}px`, //32px
      `${3 * spacer}px`, //48px
    ],
  },
)
